import { FC, useState } from 'react';
import { useQueryLocations } from '../../hooks/useLocationApi';
import { Link } from 'react-router-dom';
import FormattedMessage from '../../components/FormattedMessage';
import Spinner from '../../components/Spinner';
import { SearchBar } from '@ordr-as/umami-react/search-bar';

const Locations: FC = () => {
  const { data: locations, isPending } = useQueryLocations();
  const [search, setSearch] = useState('');

  const filteredLocations =
    locations?.filter((location) => location.name.toLowerCase().includes(search.toLowerCase())) || null;
  const hasMoreThanTenLocations = locations?.length || 0 > 10;

  return (
    <main className="h-main flex flex-col items-center bg-grey-lightest overflow-auto">
      <h1 className="mt-6 mb-5">
        <FormattedMessage id="locations.header" />
      </h1>

      {isPending && <Spinner className="w-8 h-8" />}
      {locations && (
        <>
          <ul className="w-full max-w-lg px-2 divide-y divide-grey-medium">
            {hasMoreThanTenLocations && (
              <SearchBar aria-label="search" fullWidth value={search} setValue={setSearch} setActive={() => true} />
            )}
            {filteredLocations &&
              filteredLocations.map((location) => (
                <li className="bg-brand-white" key={location.locationId}>
                  <Link className="block p-4" to={`/${location.locationId}`}>
                    {location.name}
                  </Link>
                </li>
              ))}
          </ul>
        </>
      )}
    </main>
  );
};
export default Locations;
